import React from "react";

function Loader() {
  return (
    <div id="preloader">
      <div id="status">
        <div className="spinner" />
      </div>
    </div>
  );
}

export default Loader;
